import * as r from "react";
import e from "../lib/IconBase.es.js";
import s from "../defs/ArrowsOutCardinal.es.js";
const o = r.forwardRef((a, t) => /* @__PURE__ */ r.createElement(e, { ref: t, ...a, weights: s }));
o.displayName = "ArrowsOutCardinalIcon";
const m = o;
export {
  m as ArrowsOutCardinal,
  o as ArrowsOutCardinalIcon
};
